<mat-autocomplete
  requireSelection
  [autoActiveFirstOption]="autoActiveFirstOption"
  [displayWith]="activeOptionLabel"
  #auto="matAutocomplete"
>
  @for (c of filteredChoices$ | async; track c) {
  <mat-option [value]="c">
    @if (choiceOptionTemplate) {
    <ng-container
      [ngTemplateOutlet]="choiceOptionTemplate"
      [ngTemplateOutletContext]="{ $implicit: c }"
    >
    </ng-container>
    } @else { {{ c.name }} }
  </mat-option>
  }
</mat-autocomplete>
<mat-chip-grid #chipList>
  @for (c of displayedSelections$ | async; track c) {
  <mat-chip (removed)="remove(c)">
    {{c.name}}
    <button matChipRemove>
      <mat-icon>cancel</mat-icon>
    </button>
  </mat-chip>
  }
  <input
    #chipsInput
    matInput
    type="text"
    (blur)="onTouched()"
    (input)="onTextInput($event)"
    [formControl]="internalControl"
    [matAutocomplete]="auto"
    [matChipInputFor]="chipList"
    [matChipInputSeparatorKeyCodes]="confirmKeys"
    (matChipInputTokenEnd)="onChipInputTokenEnd()"
  />
</mat-chip-grid>
